import striveMark from './assets/strive-mark.png';

import RemoteTabs from './Tab';
import './main.css'
import './f_style.css'

export default function Inactive(props) {
    const uid = props.uid;
	const status = props.active;
	const name = props.driver_name;
    const passenger_id = props.passenger_id
    const start = props.start
    const alias = props.alias;
    const idx = props.idx

    return (
        <div className='dark-container' style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ padding: '40px 24px', textAlign: 'center' }}>
                <img className='brand-logo' src={striveMark} alt='Strive.FM' width='48' height='48' style={{ width: '48px', height: '48px', margin: '0 auto 16px' }} />
                <h1 style={{ color: '#f0f0f2', fontSize: '20px', fontWeight: 600, margin: '0 0 8px' }}>
                    {(alias !== "") ? alias : "Your driver"}&#39;s session is inactive
                </h1>
                <p style={{ color: 'rgba(240,240,242,0.5)', fontSize: '14px', margin: 0 }}>
                    Let {(alias !== "") ? alias : "your driver"} know to start session :)
                </p>
            </div>
            <div style={{ width: '100%', flex: 1 }}>
                <RemoteTabs uid={uid} active={status} passenger={passenger_id} start={start} idx={idx}/>
            </div>
            <div className='remote_waves'>
                <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                    <defs>
                        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                    </defs>
                    <g className="parallax">
                        <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(108,114,255,0.15)" />
                        <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(108,114,255,0.10)" />
                        <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(108,114,255,0.05)" />
                        <use xlinkHref="#gentle-wave" x="48" y="7" fill="#0d0d0d" />
                    </g>
                </svg>
            </div>
        </div>
    )
}
